import { HorizontalSafeAreaContainer } from '../../../../components';
import { useHorizontalSafeAreaHeaderOptions } from '../../../../hooks';
import { RateOrderScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  useHorizontalSafeAreaHeaderOptions();

  return (
    <HorizontalSafeAreaContainer>
      <RateOrderScreen />
    </HorizontalSafeAreaContainer>
  );
}
